export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const IMAGE_PLACEHOLDER = 'https://via.placeholder.com/320x240';
export const IMAGE_FILE_HINT =
  'File requirement: JPG, PNG, GIF, or WEBP up to 10 MB. Minimum pixels required: 320 for width and height.';
export const REORDER_DEBOUNCE_MS = 500;
export const SEARCH_DEBOUNCE_MS = 600;

export const QUERY_KEYS = {
  CATEGORIES: 'menu-categories',
  ALL_ITEMS: 'all-items-for-category-picker',
} as const;
